import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

import AlreadyLinked from "./layout/AlreadyLinked";
import LinkToSelf from "./layout/LinkToSelf";
import JwtExpired from "./layout/JwtExpired";
import JwtError from "./layout/JwtError";
import SuccessLinked from "./layout/SuccessLinked";
import CreateAccount from "./layout/CreateAccount";

import LoginInvite from "./layout/LoginInvite";
import Axios from "../../_services/caller.service";
import styles from "./UserAccountLinker.module.scss";
import CardHeaderPage from "../UiComponents/card/CardHeaderPage";
import logo from "../../pics/logo-hearingspace.png";
import { MdAccountCircle } from "react-icons/md";
import { MdOutlineAssignmentInd } from "react-icons/md";

const UserAccountLinker = () => {
  const { t } = useTranslation();
  //TOKEN URL
  const [token, setToken] = useState(false); //token verify true or false
  const [jwtExpired, setJwtExpired] = useState(false); // if jwt is expired
  const [jwtError, setJwtError] = useState(false); // if jwt not good
  const [jwtAlreadyUSe, setJwtAlreadyUSe] = useState(false); // if invite link already use
  // USER
  const [emailUser, setEmailUser] = useState(""); //user mail
  const [userId, setUserId] = useState(""); // user's invite ID
  const [userName, setUserName] = useState("");

  //NAME AND LASTNAME IN TOKEN
  const [nameUser, setNameUser] = useState("");
  const [lastNameUser, setLastNameUser] = useState("");
  //OWNER
  const [ownerId, setOwnerId] = useState(0); // owner id
  const [senderOwner, setSenderOwner] = useState(""); //name owner
  const [emailOwner, setEmailOwner] = useState(""); //name owner
  const [hashId, setHashId] = useState(""); //hash == n° unique pour être encodé dans le payload token pour être sur de supprimer l'email dans invitList

  //FOR EMAIL SUCCESS
  const [nameForEmailSuccess, setNameForEmailSuccess] = useState("");
  const [lastNameForEmailSuccess, setLastNameForEmailSucess] = useState("");

  //CONNEXION STATUS
  const [confirmLinked, setConfirmLinked] = useState(false); // user in email is the same to userConnect
  const [successLinked, setSuccessLinked] = useState(false);

  //After User create an account
  const [accountCreate, setAccountCreate] = useState(false);

  // SIGNIN STATE
  const [userMailSignIn, setUserMailSignIn] = useState("");
  const [userPasswordSignIn, setUserPasswordSignIn] = useState("");

  //ERROR
  const [linkToSelf, setLinkToSelf] = useState(false); // userConnection dismatch with email url link
  const [alreadyLinked, setAlreadyLinked] = useState(false);

  //REGISTER
  const [displaySignUpModal, setDisplaySignUpModal] = useState(false);
  //DISPLAY
  const [displayLogin, setDisplayLogin] = useState(false);
  const [displayNewAccount, setDisplayNewAccount] = useState(false);

  // SECURITE F6 : le JWT d'invitation est desormais transporte par le
  // cookie httpOnly hs_invite (pose par /verifyTokenInUrl et /inviteUserLogin).
  // Plus de localStorage, donc pas exfiltrable via XSS.

  // VERIFY TOKEN IN URL

  
  useEffect(() => {
    let params = new URLSearchParams(document.location.search);

    let token = params.get("token"); // token verify in backend

    Axios.post(`/verifyTokenInUrl/`, { token })

      .then(function (response) {
        
        if (response.data.msg === "jwt expired") {
          setJwtExpired(true);
        }
        if (response.data.name === "JsonWebTokenError") {
          setJwtError(true);
        }
        if (response.data.msg === "invite already use") {
          setJwtAlreadyUSe(true);
        } else {
          // F6 : le serveur a deja pose le cookie httpOnly hs_invite, plus
          // besoin de stocker le token cote client.
          setToken(response.data.tokenStatus);
          setEmailUser(response.data.email);
          setOwnerId(response.data.ownerId);
          setSenderOwner(response.data.senderOwner);
          setEmailOwner(response.data.emailOwner);
          setHashId(response.data.hash);

          setNameUser(
            response.data.name[0].toUpperCase() + response.data.name.slice(1)
          );
          setLastNameUser(
            response.data.lastName[0].toUpperCase() +
              response.data.lastName.slice(1)
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // CONFIRM INVITATION  ICI userInviteId est l'id généré lors de la création de compte ou celui déja existant si déja un compte
const confirmInvitation = (userInviteId) => {
  // NE PAS MODIFIER axios par AXIOS
  // F6 : pas d'header Authorization, le cookie httpOnly hs_invite voyage
  // automatiquement grace a withCredentials.
  axios
    .post(
      `${process.env.REACT_APP_API_URL}api/confirmInvitation/${userInviteId}`,
      {
        ownerId,
      },
      {
        withCredentials: true,
      }
    )

    .then(function (response) {
      if (response.data.msg === "already linked") {
        setAlreadyLinked(true);

        axios
          .delete(
            `${process.env.REACT_APP_API_URL}api/deleteInviteList/${emailUser}/${hashId}`,
            {
              withCredentials: true,
            }
          )
          .then(function () {
            // F6 : le cookie hs_invite est purge cote serveur.
          })
          .catch(function (error) {
            console.log(error);
          });
      }

      if (response.data.msg === "link to self") {
        setLinkToSelf(true);

        axios
          .delete(
            `${process.env.REACT_APP_API_URL}api/deleteInviteList/${emailUser}/${hashId}`,
            {
              withCredentials: true,
            }
          )
          .then(function () {})
          .catch(function () {});
      }

      if (response.data.msg === "success linked") {
        // 🔥 L'EMAIL EST DÉSORMAIS ENVOYÉ CÔTÉ BACKEND (confirmInvitation)
        axios
          .delete(
            `${process.env.REACT_APP_API_URL}api/deleteInviteList/${emailUser}/${hashId}`,
            {
              withCredentials: true,
            }
          )
          .then(function () {})
          .catch(function (error) {
            console.log(error);
          });

        setSuccessLinked(true);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};


  return (
    <div className={styles.container}>
      <img src={logo} className={styles.logo} alt="Hearing Space" />

      {!successLinked && (
        <CardHeaderPage
          text={t("invite.welcome_title", { name: nameUser, lastName: lastNameUser })}
        />
      )}

      {token && !successLinked && !linkToSelf && !alreadyLinked && (
        <div className={styles.containerLoginAndCreate}>
          <div className={styles.infos}>
            <p>
              {t("invite.existing_account_message", { owner: senderOwner })}
            </p>
          </div>
          <div className={styles.containerBtn}>
            <button
              className={displayLogin ? styles.btnChoiceActive : styles.btnChoice}
              onClick={() => {
                setDisplayLogin(true);
                setDisplayNewAccount(false);
              }}
            >
              <MdAccountCircle /> {t("invite.login_button")}
            </button>
            <button
              className={displayNewAccount ? styles.btnChoiceActive : styles.btnChoice}
              onClick={() => {
                setDisplayNewAccount(true);
                setDisplayLogin(false);
              }}
            >
              <MdOutlineAssignmentInd /> {t("invite.create_account_button")}
            </button>
          </div>

          {displayLogin && (
            <LoginInvite
              emailUser={emailUser}
              setConfirmLinked={setConfirmLinked}
              setUserId={setUserId}
              setUserName={setUserName}
              userMailSignIn={userMailSignIn}
              userPasswordSignIn={userPasswordSignIn}
              setUserMailSignIn={setUserMailSignIn}
              setUserPasswordSignIn={setUserPasswordSignIn}
              senderOwner={senderOwner}
              confirmInvitation={confirmInvitation}
              setNameForEmailSuccess={setNameForEmailSuccess}
            />
          )}
          {displayNewAccount && (
            <CreateAccount
              setDisplaySignUpModal={setDisplaySignUpModal}
              setAccountCreate={setAccountCreate}
              setUserMailSignIn={setUserMailSignIn}
              setUserPasswordSignIn={setUserPasswordSignIn}
              senderOwner={senderOwner}
              confirmInvitation={confirmInvitation}
              setNameForEmailSuccess={setNameForEmailSuccess}
              setLastNameForEmailSucess={setLastNameForEmailSucess}
            />
          )}
        </div>
      )}

      {successLinked && (
        <>
          <CardHeaderPage text={t("invite.welcome_success", { name: userName })} />
          <SuccessLinked userName={userName} senderOwner={senderOwner} />
        </>
      )}

      {alreadyLinked && (
        <AlreadyLinked senderOwner={senderOwner} emailUser={emailUser} />
      )}
      {linkToSelf && <LinkToSelf />}

      {jwtExpired && <JwtExpired />}
      {jwtAlreadyUSe && (
        <div className={styles.statusCard}>
          <h2>{t("invite.link_expired")}</h2>
          <p>{t("invite.link_expired_contact")}</p>
        </div>
      )}
      {jwtError && <JwtError />}
    </div>
  );
};

export default UserAccountLinker;
